
function concertinas() {
    jQuery('.is-style-concertina:not(.initiliased)').each(function () {
        // Remove tags inside title
        let title = jQuery(this).text();
        jQuery(this).empty();
        jQuery(this).text(title);

        jQuery(this).addClass('initiliased')
            .nextUntil('.is-style-concertina, .is-style-concertina-end')
            .wrapAll('<div class="concertina-content js-concertina-content" />');
    });

    /*jQuery('.is-style-concertina:first').addClass('is-down');
    jQuery('.concertina-content:not(:first)').slideUp(1);*/
    jQuery('.is-style-concertina').addClass('is-down');
    jQuery('.concertina-content').slideUp(1);

    jQuery('.is-style-concertina').on('click', function () {
        jQuery(this).toggleClass('is-down');
        jQuery(this).next('.concertina-content').slideToggle(300);
    });
}

module.exports = concertinas;